export default import.meta.ROLLDOWN_FILE_URL_VRAku6fjghkApIISiBWPzg_44fee6517141fecb989b916d